import { JsonProperty, JsonObject, Any } from 'json2typescript';
import { ModelObject } from '@hermes/api-model-core';
import { Basket, ErrorItem } from '@hermes/api-model-basket';
import { Address } from '@hermes/api-model-address';
import { Metadatas } from '@hermes/api-model-head';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 *
 * @param data
 */
function noopSerializer(data) {
    return data;
}

let DistrictResponse = class DistrictResponse extends ModelObject {
    constructor() {
        super(...arguments);
        this.district = undefined;
    }
};
__decorate([
    JsonProperty("district", {
        deserialize: noopSerializer,
        serialize: noopSerializer,
    }),
    __metadata("design:type", Object)
], DistrictResponse.prototype, "district", undefined);
DistrictResponse = __decorate([
    JsonObject("DistrictResponse")
], DistrictResponse);

let DistrictsBisResponse = class DistrictsBisResponse extends ModelObject {
    constructor() {
        super(...arguments);
        this.districts = undefined;
    }
};
__decorate([
    JsonProperty("districts", {
        deserialize: noopSerializer,
        serialize: noopSerializer,
    }),
    __metadata("design:type", Object)
], DistrictsBisResponse.prototype, "districts", undefined);
__decorate([
    JsonProperty("districtByCity", Boolean, true),
    __metadata("design:type", Boolean)
], DistrictsBisResponse.prototype, "districtByCity", undefined);
__decorate([
    JsonProperty("districtByRegion", Boolean, true),
    __metadata("design:type", Boolean)
], DistrictsBisResponse.prototype, "districtByRegion", undefined);
DistrictsBisResponse = __decorate([
    JsonObject("DistrictsBisResponse")
], DistrictsBisResponse);

class CheckoutWebToShopRequest {
}

let CheckoutWebToShopResponse = class CheckoutWebToShopResponse {
    constructor() {
        this.basket = undefined;
        this.error = undefined;
    }
};
__decorate([
    JsonProperty("basket", Basket, true),
    __metadata("design:type", Basket)
], CheckoutWebToShopResponse.prototype, "basket", undefined);
__decorate([
    JsonProperty("error", ErrorItem, true),
    __metadata("design:type", ErrorItem)
], CheckoutWebToShopResponse.prototype, "error", undefined);
CheckoutWebToShopResponse = __decorate([
    JsonObject("CheckoutWebToShopResponse")
], CheckoutWebToShopResponse);

let CallingHoursInfos = class CallingHoursInfos {
    constructor() {
        this.days = undefined;
        this.opening_hours = undefined;
        this.closing_hours = undefined;
        this.timezone = undefined;
    }
};
__decorate([
    JsonProperty("days", String, true),
    __metadata("design:type", String)
], CallingHoursInfos.prototype, "days", undefined);
__decorate([
    JsonProperty("opening_hours", String, true),
    __metadata("design:type", String)
], CallingHoursInfos.prototype, "opening_hours", undefined);
__decorate([
    JsonProperty("closing_hours", String, true),
    __metadata("design:type", String)
], CallingHoursInfos.prototype, "closing_hours", undefined);
__decorate([
    JsonProperty("timezone", String, true),
    __metadata("design:type", String)
], CallingHoursInfos.prototype, "timezone", undefined);
CallingHoursInfos = __decorate([
    JsonObject("CallingHoursInfo")
], CallingHoursInfos);

let ContactInfos = class ContactInfos {
    constructor() {
        this.description = undefined;
        this.phone = undefined;
        this.calling_hours = undefined;
    }
};
__decorate([
    JsonProperty("description", String, true),
    __metadata("design:type", String)
], ContactInfos.prototype, "description", undefined);
__decorate([
    JsonProperty("phone", String, true),
    __metadata("design:type", String)
], ContactInfos.prototype, "phone", undefined);
__decorate([
    JsonProperty("calling_hours", [CallingHoursInfos], true),
    __metadata("design:type", Array)
], ContactInfos.prototype, "calling_hours", undefined);
ContactInfos = __decorate([
    JsonObject("ContactInfos")
], ContactInfos);

let Fapiao = class Fapiao {
    constructor(fapiao) {
        this.type = fapiao.type;
        this.name = fapiao.name;
        this.companyName = fapiao.companyName;
        this.taxId = fapiao.taxId;
        this.companyAddress = fapiao.companyAddress;
        this.companyPhoneNumber = fapiao.companyPhoneNumber;
        this.companyBankAccount = fapiao.companyBankAccount;
    }
};
__decorate([
    JsonProperty("type"),
    __metadata("design:type", String)
], Fapiao.prototype, "type", undefined);
__decorate([
    JsonProperty("name"),
    __metadata("design:type", String)
], Fapiao.prototype, "name", undefined);
__decorate([
    JsonProperty("company_name"),
    __metadata("design:type", String)
], Fapiao.prototype, "companyName", undefined);
__decorate([
    JsonProperty("tax_id"),
    __metadata("design:type", String)
], Fapiao.prototype, "taxId", undefined);
__decorate([
    JsonProperty("company_address"),
    __metadata("design:type", String)
], Fapiao.prototype, "companyAddress", undefined);
__decorate([
    JsonProperty("company_phone_number"),
    __metadata("design:type", String)
], Fapiao.prototype, "companyPhoneNumber", undefined);
__decorate([
    JsonProperty("company_bank_account"),
    __metadata("design:type", String)
], Fapiao.prototype, "companyBankAccount", undefined);
Fapiao = __decorate([
    JsonObject("Fapiao"),
    __metadata("design:paramtypes", [Fapiao])
], Fapiao);

let Ecpay = class Ecpay {
    constructor() {
        this.code = undefined;
        this.service = undefined;
        this.type = undefined;
        this.address = undefined;
        this.mobileBarcode = undefined;
        this.voucherId = undefined;
        this.donationLovecode = undefined;
    }
};
__decorate([
    JsonProperty("code", Number),
    __metadata("design:type", Number)
], Ecpay.prototype, "code", undefined);
__decorate([
    JsonProperty("service", String),
    __metadata("design:type", String)
], Ecpay.prototype, "service", undefined);
__decorate([
    JsonProperty("type", String),
    __metadata("design:type", String)
], Ecpay.prototype, "type", undefined);
__decorate([
    JsonProperty("address", Address, true),
    __metadata("design:type", Address)
], Ecpay.prototype, "address", undefined);
__decorate([
    JsonProperty("mobile_barcode", String, true),
    __metadata("design:type", String)
], Ecpay.prototype, "mobileBarcode", undefined);
__decorate([
    JsonProperty("voucher_id", String, true),
    __metadata("design:type", String)
], Ecpay.prototype, "voucherId", undefined);
__decorate([
    JsonProperty("donation_lovecode", String, true),
    __metadata("design:type", String)
], Ecpay.prototype, "donationLovecode", undefined);
Ecpay = __decorate([
    JsonObject("ecpay")
], Ecpay);

let TaxInvoice = class TaxInvoice {
    constructor(source) {
        this.fullTaxInvoice = undefined;
        this.taxId = undefined;
        this.companyBranch = undefined;
        this.branchNumber = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("full_tax_invoice", Boolean, true),
    __metadata("design:type", Boolean)
], TaxInvoice.prototype, "fullTaxInvoice", undefined);
__decorate([
    JsonProperty("tax_id", String, true),
    __metadata("design:type", String)
], TaxInvoice.prototype, "taxId", undefined);
__decorate([
    JsonProperty("company_branch", String, true),
    __metadata("design:type", String)
], TaxInvoice.prototype, "companyBranch", undefined);
__decorate([
    JsonProperty("branch_number", String, true),
    __metadata("design:type", String)
], TaxInvoice.prototype, "branchNumber", undefined);
TaxInvoice = __decorate([
    JsonObject("TaxInvoice"),
    __metadata("design:paramtypes", [TaxInvoice])
], TaxInvoice);

let OrangeBoxDatas = class OrangeBoxDatas {
    constructor() {
        this.title = undefined;
        this.imgSrc = undefined;
        this.content = undefined;
        this.infoLinkLabel = undefined;
        this.infoLinkUrl = undefined;
    }
};
__decorate([
    JsonProperty("title", String, true),
    __metadata("design:type", String)
], OrangeBoxDatas.prototype, "title", undefined);
__decorate([
    JsonProperty("img_src", String, true),
    __metadata("design:type", String)
], OrangeBoxDatas.prototype, "imgSrc", undefined);
__decorate([
    JsonProperty("content", String, true),
    __metadata("design:type", String)
], OrangeBoxDatas.prototype, "content", undefined);
__decorate([
    JsonProperty("info_link_label", String, true),
    __metadata("design:type", String)
], OrangeBoxDatas.prototype, "infoLinkLabel", undefined);
__decorate([
    JsonProperty("info_link_url", String, true),
    __metadata("design:type", String)
], OrangeBoxDatas.prototype, "infoLinkUrl", undefined);
OrangeBoxDatas = __decorate([
    JsonObject("OrangeBoxDatas")
], OrangeBoxDatas);

/**
 * This class define cart page infos properties with the dac informations
 */
let CustomerServiceInfos = class CustomerServiceInfos {
    constructor() {
        /** customerServiceInfos title */
        this.title = undefined;
        /** customerServiceInfos contact infos */
        this.contactInfos = undefined;
        /** customerServiceInfos contact title */
        this.contactTitle = undefined;
        /** customerServiceInfos body */
        this.body = undefined;
    }
};
__decorate([
    JsonProperty("title", String, true),
    __metadata("design:type", String)
], CustomerServiceInfos.prototype, "title", undefined);
__decorate([
    JsonProperty("contact_infos", [ContactInfos], true),
    __metadata("design:type", Array)
], CustomerServiceInfos.prototype, "contactInfos", undefined);
__decorate([
    JsonProperty("contact_title", String, true),
    __metadata("design:type", String)
], CustomerServiceInfos.prototype, "contactTitle", undefined);
__decorate([
    JsonProperty("body", String, true),
    __metadata("design:type", String)
], CustomerServiceInfos.prototype, "body", undefined);
CustomerServiceInfos = __decorate([
    JsonObject("CustomerServiceInfos")
], CustomerServiceInfos);

/**
 * This class define checkout page properties with the dac informations
 */
let CheckoutPage = class CheckoutPage {
    constructor() {
        /** checkoutPage metas */
        this.metas = undefined;
        /** checkoutPage orangeBoxDatas */
        this.orangeBoxDatas = undefined;
        /** checkoutPage customerService */
        this.customerService = undefined;
        /** checkoutPage freeStandardDeliveryFilter */
        this.freeStandardDeliveryFilter = undefined;
    }
};
__decorate([
    JsonProperty("metas", Metadatas, true),
    __metadata("design:type", Metadatas)
], CheckoutPage.prototype, "metas", undefined);
__decorate([
    JsonProperty("orange_box_datas", OrangeBoxDatas, true),
    __metadata("design:type", OrangeBoxDatas)
], CheckoutPage.prototype, "orangeBoxDatas", undefined);
__decorate([
    JsonProperty("customer_service", CustomerServiceInfos, true),
    __metadata("design:type", CustomerServiceInfos)
], CheckoutPage.prototype, "customerService", undefined);
__decorate([
    JsonProperty("free_standard_delivery_filter", [String], true),
    __metadata("design:type", Array)
], CheckoutPage.prototype, "freeStandardDeliveryFilter", undefined);
CheckoutPage = __decorate([
    JsonObject("CheckoutPage")
], CheckoutPage);

/**
 * This class define address field config for address forms
 */
let AddressFieldConfig = class AddressFieldConfig {
};
__decorate([
    JsonProperty("fields", [Any], false)
    // any[] because no type in ngx-formly lib
    ,
    __metadata("design:type", Array)
], AddressFieldConfig.prototype, "fields", undefined);
AddressFieldConfig = __decorate([
    JsonObject("AddressFieldConfig")
], AddressFieldConfig);

/**
 * This class define checkout page infos properties with the dac informations
 */
let CheckoutPageInfos = class CheckoutPageInfos {
    constructor() {
        /** checkoutPage metas */
        this.metas = undefined;
    }
};
__decorate([
    JsonProperty("metas", Metadatas),
    __metadata("design:type", Metadatas)
], CheckoutPageInfos.prototype, "metas", undefined);
CheckoutPageInfos = __decorate([
    JsonObject("CheckoutPageInfos")
], CheckoutPageInfos);

let CfdiProperties = class CfdiProperties {
};
__decorate([
    JsonProperty("razonSocial", String, false),
    __metadata("design:type", String)
], CfdiProperties.prototype, "razonSocial", undefined);
__decorate([
    JsonProperty("regimenFiscal", String, false),
    __metadata("design:type", String)
], CfdiProperties.prototype, "regimenFiscal", undefined);
__decorate([
    JsonProperty("rfc", String, false),
    __metadata("design:type", String)
], CfdiProperties.prototype, "rfc", undefined);
__decorate([
    JsonProperty("usoCfdi", String, false),
    __metadata("design:type", String)
], CfdiProperties.prototype, "usoCfdi", undefined);
CfdiProperties = __decorate([
    JsonObject("CfdiProperties")
], CfdiProperties);

let CfdiList = class CfdiList {
};
__decorate([
    JsonProperty("regimenFiscalList", Object, false),
    __metadata("design:type", Array)
], CfdiList.prototype, "regimenFiscalList", undefined);
__decorate([
    JsonProperty("usoCfdiList", Object, false),
    __metadata("design:type", Array)
], CfdiList.prototype, "usoCfdiList", undefined);
CfdiList = __decorate([
    JsonObject("CfdiList")
], CfdiList);

export { AddressFieldConfig, CallingHoursInfos, CfdiList, CfdiProperties, CheckoutPage, CheckoutPageInfos, CheckoutWebToShopRequest, CheckoutWebToShopResponse, ContactInfos, CustomerServiceInfos, DistrictResponse, DistrictsBisResponse, Ecpay, Fapiao, OrangeBoxDatas, TaxInvoice };
